// extracted by mini-css-extract-plugin
export var askAiIcon = "_r1-9";
export var container = "_r1-0";
export var groupSeparator = "_r1-a";
export var highlight = "_r1-4";
export var resultIcon = "_r1-5";
export var resultItem = "_r1-7";
export var resultSubtitle = "_r1-3";
export var resultTitle = "_r1-2";
export var resultsList = "_r1-1";
export var searchGroup = "_r1-6";
export var selected = "_r1-8";